import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to enable exclusivity agreements for retailers
 */
export const ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915 =
  'ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915' as SettingConst<
    'ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'HELP_CENTER'
  >;
